import React from "react";
import { string, number, func } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import GoogleAuth from "../../atoms/google-auth";
import FacebookAuth from "../../atoms/facebook-auth";

import { setMember, setLoading, setUserPlans } from "../../helper/actions";

import "./login-view.m.css";

const LoginView = ({ navigateToPage, closePopup, googleClientId, facebookId, setMember, setLoading, setUserPlans }) => {
  const subscribeClick = () => {
    closePopup();
    navigateToPage("/support");
  };

  return (
    <div styleName="wrapper">
      <span styleName="login-title">Welcome Back.</span>
      <span styleName="description">Log in to get the complete ad free experience</span>

      <GoogleAuth
        text="Continue with Google"
        googleClientId={googleClientId}
        setMember={setMember}
        setLoading={setLoading}
        closePopup={closePopup}
        setUserPlans={setUserPlans}
      />

      <div styleName="facebook-auth">
        <FacebookAuth
          text="Continue with Facebook"
          facebookId={facebookId}
          setMember={setMember}
          setLoading={setLoading}
          closePopup={closePopup}
          setUserPlans={setUserPlans}
        />
      </div>

      <div styleName="account">
        <span styleName="subscribe" onClick={subscribeClick}>
          Subscribe Now!
        </span>
      </div>
    </div>
  );
};

LoginView.propTypes = {
  navigateToPage: func,
  closePopup: func,
  googleClientId: string,
  facebookId: number,
  setMember: func,
  setLoading: func,
  setUserPlans: func
};

const mapStateToProps = state => ({
  googleClientId: get(state, ["qt", "config", "publisher-attributes", "socialAuth", "google"], ""),
  facebookId: get(state, ["qt", "config", "publisher-attributes", "socialAuth", "fb"], "")
});

const mapDispatchToProps = dispatch => ({
  navigateToPage: url => global.app.navigateToPage(dispatch, url),
  setMember: member => dispatch(setMember(member)),
  setLoading: isLoading => dispatch(setLoading(isLoading)),
  setUserPlans: list => dispatch(setUserPlans(list))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginView);
